<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="card-checklist" class="icon"></b-icon>
            <span>รายการซัพพลายเออร์</span>
        </div>

        <div class="content">
            <div class="filter form mb-4">
                <supplier-filter @lookup="filterSupplierList($event)"></supplier-filter>
            </div>

            <div class="mb-4 text-right">
                <button class="btn btn-main" @click="openSupplierForm('')">เพิ่มซัพพลายเออร์</button>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>ชื่อซัพพลายเออร์</th>
                            <th>ผู้ติดต่อ</th>
                            <th>เบอร์ติดต่อ</th>
                            <th>รายละเอียดอื่นๆ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in supplierList" :key="index">
                            <td class="text-center text-nowrap">
                                <button class="icon" @click="openSupplierForm(item.key)"><b-icon icon="pencil"></b-icon></button>
                                <button class="icon" @click="deleteSupplier(item)"><b-icon icon="trash"></b-icon></button>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.contactPerson }}</td>
                            <td>
                                <span class="text-nowrap"><b-icon icon="telephone" class="icon"></b-icon> {{ item.contactTel }}</span>
                            </td>
                            <td>{{ item.detail }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="supplierList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่พบรายชื่อซัพพลายเออร์</span>
            </div>
        </div>

        <supplier-modal-form :isDisplay="isShowSupplierForm" :keyData="supplierKeyId" @hide="closeSupplierForm($event)"></supplier-modal-form>
    </div>
</template>

<script>
import SupplierFilter from '@/components/supplier/Filter';
import SupplierModalForm from '@/components/supplier/ModalForm';
import DBSupplier from '@/database/Supplier';
import ModelKeywordFilter from '@/resources/models/KeywordFilter';

export default {
    components: {
        SupplierFilter,
        SupplierModalForm
    },
    data() {
        return {
            isShowSupplierForm: false,
            supplierKeyId: '',
            supplierList: [],
            supplierFilter: ModelKeywordFilter.data(),
            isLoading: false
        }
    },
    mounted() {
        this.loadSupplierList();
    },
    methods: {
        openSupplierForm(key) {
            this.supplierKeyId = key;
            this.isShowSupplierForm = true;
        },
        closeSupplierForm(isReload) {
            this.isShowSupplierForm = false;

            if (isReload) {
                this.loadSupplierList();
            }
        },
        filterSupplierList(value) {
            this.supplierFilter = value;
            this.loadSupplierList();
        },
        filterResult(result) {
            if (this.supplierFilter.keyword) {
                result = result.filter(x => x.name?.toLowerCase().indexOf(this.supplierFilter.keyword.toLowerCase()) > -1 
                                            || x.contactPerson?.toLowerCase().indexOf(this.supplierFilter.keyword.toLowerCase()) > -1
                                            || x.contactTel?.toLowerCase().indexOf(this.supplierFilter.keyword.toLowerCase()) > -1
                                            || x.detail?.toLowerCase().indexOf(this.supplierFilter.keyword.toLowerCase()) > -1);
            }

            return result;
        },
        async loadSupplierList() {
            this.isLoading = true;
            this.supplierList = [];
            const result = await DBSupplier.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Place into the Object
                this.supplierList = result.content;
            }

            this.isLoading = false;
        },
        deleteSupplier(item) {
            this.$swal({
                title: 'ลบข้อมูลซัพพลายเออร์?',
                text: 'โปรดยืนยันว่าต้องการลบข้อมูลซัพพลายเออร์',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    await DBSupplier.delete(item);

                    this.loadSupplierList();
                    loader.hide();
                }
            });
        }
    }
}
</script>